export default "__VITE_ASSET__AuXXi86U__"